import React from "react";

interface ConsentSectionProps {
  consent: { user: boolean; patient: boolean };
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  variant?: "cases" | "smile" | "uris";
}

const ConsentSection: React.FC<ConsentSectionProps> = ({
  consent,
  handleChange,
  disabled = false,
  variant = "cases",
}) => {
  const isSmile = variant === "smile";
  const isUris = variant === "uris";

  const headingClass = isUris
    ? "text-[15px] mt-2 font-bold text-white border-b-2 border-[#c31c30] uppercase mb-4"
    : isSmile
    ? "text-[15px] mt-2 font-bold text-white border-b-2 border-cyan-500 uppercase mb-4"
    : "text-[15px] mt-2 font-bold text-gray-800 border-b-2 border-[#2fa9bf] uppercase mb-4";

  const bodyClass = isUris
    ? "space-y-4 text-[#c5c7cc] text-sm md:text-[15px] px-4"
    : isSmile
    ? "space-y-4 text-[#c7ccca] text-sm md:text-[15px] px-4"
    : "space-y-4 text-gray-800 text-sm md:text-[15px] px-4";

  return (
    <>
      <h2 className={headingClass}>
        User Consent
      </h2>
      <div className={bodyClass}>
        {[
          {
            name: "user",
            label:
              "I consent to my data being held on the system for the purpose of providing me with your services.",
          },
          {
            name: "patient",
            label:
              "I confirm that any patient data I place on your system is done so with the consent of the patient.",
          },
        ].map((item) => (
          <label key={item.name} className="flex items-start gap-3">
            <input
              type="checkbox"
              name={item.name}
              checked={(consent as any)[item.name]}
              onChange={handleChange}
              className={`mt-1 w-4 h-4 cursor-pointer ${
                isUris ? "accent-[#c31c30]" : isSmile ? "accent-cyan-500" : ""
              }`}
              disabled={disabled}
            />
            <span>{item.label}</span>
          </label>
        ))}
      </div>
    </>
  );
};

export default ConsentSection;
